import type { ReactNode, CSSProperties } from 'react';
import classnames from 'classnames';

import style from './style.scss';

interface Props<T> {
  options: { label: ReactNode; value: T }[];
  value?: T;
  selectedColor?: 'green' | 'blue';
  onChange?: (value: T) => void;
  className?: string;
  style?: CSSProperties;
}

const selectedClassNameMap = {
  green: style.selected_green,
  blue: style.selected_blue
};

const RadioBlock = <T extends string | number>({
  options,
  value,
  selectedColor = 'green',
  onChange,
  className,
  style: css
}: Props<T>): JSX.Element => (
  <div className={classnames(style.container, className)} style={css}>
    {options.map(option => {
      const optionClassName = classnames(style.option, {
        [style.option_selected]: option.value === value
      });
      const handleChange = onChange ? () => onChange(option.value) : undefined;

      return (
        <button key={option.value} type="button" className={optionClassName} onClick={handleChange}>
          <span className={style.label}>{option.label}</span>
          <span className={classnames(style.selected, selectedClassNameMap[selectedColor])}>
            {option.label}
          </span>
        </button>
      );
    })}
  </div>
);

RadioBlock.displayName = 'RadioBlock';

export default RadioBlock;
